import $5ff8cad6 from "/srv/webapps/td-eg-solo-frontend/production/releases/20251117085329/middleware/category-redirect.ts";
import $296b2dd2 from "/srv/webapps/td-eg-solo-frontend/production/releases/20251117085329/middleware/redirect.ts";
const middleware = {
  "category-redirect": $5ff8cad6,
  redirect: $296b2dd2
}
export default middleware